import {store} from "./store";

export const useNavigation = store;
